import { render } from "./SiteAddressSetupNotice.vue?vue&type=template&id=6efb260a"
import script from "./SiteAddressSetupNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteAddressSetupNotice.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/SiteAddressSetupNotice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6efb260a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6efb260a', __exports__)) {
    api.reload('6efb260a', __exports__)
  }
  
  module.hot.accept("./SiteAddressSetupNotice.vue?vue&type=template&id=6efb260a", () => {
    api.rerender('6efb260a', render)
  })

}


export default __exports__